import React from 'react';
import PropTypes from 'prop-types';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import Component from '@plone/volto/components/theme/Component/Component';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import './styles.css';

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);  
  const day = date.getDate().toString().padStart(2, '0');
  const monthNames = ['GEN', 'FEB', 'MAR', 'APR', 'MAG', 'GIU', 
                     'LUG', 'AGO', 'SET', 'OTT', 'NOV', 'DIC'];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  if (day == 'NaN') return '';

  return `${day} ${month} ${year}`;
};

const NewsTemplate = ({ 
  items, 
  linkTitle, 
  linkHref, 
  isEditMode, 
  showPublishDate = false,
  showReadMore = false,
  readMoreText = 'Vedi tutto', 
  cardBackground = 'no-background' }) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }
  //console.log(items[0].EffectiveDate);

  return (
    <div className={`full-width-background-wrapper ${cardBackground}`}>
      <div className="news-template-container">
        <div className="news-template-inner">
          <div className="items news-listing">
            {items.map((item) => (
              <article className="listing-item news-item card-with-shadow" key={item['@id']}>
                <div className="news-image-wrapper">
                  <ConditionalLink item={item} condition={!isEditMode}>
                    <Component 
                      componentName="PreviewImage" 
                      item={item} 
                      alt=""
                      size="large"
                    />
                  </ConditionalLink>
                </div>                
                  
                <div className="news-content">                  
                  {                  
                  showPublishDate && item.EffectiveDate && item.EffectiveDate.trim() !== '' && item.EffectiveDate.trim() !== 'None' && (
                    <div className="date-with-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-newspaper" viewBox="0 0 16 16">
                        <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.528c0 .3-.05.654-.238.972h.738a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 1 1 0v9a1.5 1.5 0 0 1-1.5 1.5H1.497A1.497 1.497 0 0 1 0 13.5zM12 14c.37 0 .654-.211.853-.441.092-.106.147-.279.147-.531V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11c0 .278.223.5.497.5z" />
                        <path d="M2 3h10v2H2zm0 3h4v3H2zm0 4h4v1H2zm0 2h4v1H2zm5-6h2v1H7zm3 0h2v1h-2zM7 8h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2z" />
                      </svg>
                      <span className="publish-date">
                        {formatDate(item.EffectiveDate)}
                      </span>
                    </div>
                  )}

                  <div className="news-title-row">
                    <ConditionalLink
                      item={item}
                      condition={!isEditMode}
                      className="news-title-link"
                    ><h3>
                      {item.title || item.id}
                      </h3>
                    </ConditionalLink>
                   
                  </div>

                  {item.description && (
                    <p className="news-description">{item.description}</p>
                  )}

                  {showReadMore && (
                    <div className="read-more-link">
                      <ConditionalLink item={item} condition={!isEditMode}>
                        {readMoreText}
                      </ConditionalLink>
                    </div>
                  )}
                </div>                              
              </article>
            ))}
          </div>

          {link && <div className="footer">{link}</div>}
        </div>
      </div>
    </div>
  );
};

NewsTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
  cardBackground: PropTypes.string,
  showReadMore: PropTypes.bool,
  readMoreText: PropTypes.string,
  data: PropTypes.object,
};

export default NewsTemplate;